<template>
		<div class = "box">
			<ComNar title = "在线客服"></ComNar>
			<iframe id="servicePage" class="iframeStyle" frameborder=0
			    src="https://kf.xty86.com/chat/h5/v2/index.html?sysnum=69359ce926924775b980513c7f9e1fcf&channelid=2">
			</iframe>
		</div>
</template>
<script>
	import ComNar from '@/components/searchShop/ComNar.vue'
	export default {
		data() {
			return {
				webUrl:''
			}
		},
		components:{
			[ComNar.name]: ComNar,
		},
		onLoad(option) {
			this.webUrl = "";
			// uni.setNavigationBarTitle({
			//     title: "在线客服"
			// });
		},
	}
</script>
<style scoped>
	.box {
		width: 100%;
		height: 100%;
	}
	.iframeStyle{
		    width: 100%;
			height: calc(100% - 50px)
	}
</style>
